import React, { useEffect } from 'react';
import { Wrapper } from './styles';
import FormUtilType from './types';

export default function FormUtil(props: FormUtilType) {
  const { title } = props;
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const envelopeId = query.get('envelopeId');
    const localEnvelopeId = localStorage.getItem('ENVELOPE_ID');
    if (envelopeId && envelopeId !== localEnvelopeId) {
      localStorage.setItem('ENVELOPE_ID', envelopeId);
    }
    window.close();
  }, []);
  return <Wrapper>{title}</Wrapper>;
}

FormUtil.defaultProps = {
  title: 'Returning to Form',
};
